import gql from 'graphql-tag';
import { FeatureEventsFragment } from '@graphqlTypes';
import { Container, RevealWrapper, SectionHeader } from '@components';
import { useRef } from 'react';
import { useInView } from 'motion/react';
import { useViewSize } from '@/providers/ViewSizeContext';
import { AnimVals } from '@/utils/animUtils';

import FeatureEventsSlide from './Slide';
import FeatureEventsCarousel from './Carousel';

import styles from './FeatureEvents.module.scss';
import className from 'classnames/bind';
const cx = className.bind(styles);

export default function FeatureEvents(props: FeatureEventsFragment) {
  const { headline, subhead, events } = props;
  const eventNodes = events?.nodes;
  if (!eventNodes) return;
  const isSingle = eventNodes.length === 1;

  // -------------------- Animation

  const rootEl = useRef<HTMLDivElement>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });
  const isRevealEnabled = true;

  // -------------------- Render

  return (
    <section className={cx(["feature-events"])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        { headline && (
          <Container>
            <SectionHeader
              headline={headline}
              subhead={subhead}
              isRevealEnabled={isRevealEnabled}
              isInView={isInView}
            />
          </Container>
        )}
        { isSingle ? (
          <Container>
            <FeatureEventsSlide {...events.nodes[0]} />
          </Container>
        ) : (
          <FeatureEventsCarousel {...props} />
        )}
      </RevealWrapper>
    </section>
  );

}

FeatureEvents.fragments = {
  entry: gql`
    fragment FeatureEvents on FlexiblePageContentContentFeatureEventsLayout {
      headline
      subhead
      cta {
        linkType
        externalLink
        label
        page {
          node {
            uri
          }
        }
      }
      events {
        nodes {
          ... on Event {
            ...EventFragment
          }
        }
      }
    }
  `,
};
